import { useMutation } from '@apollo/client';
import { Permission } from '@procureai/permissions';
import { usePermissions } from '@procureai/permissions-ui';
import { useCustomSnackbar } from '@procureai/ui-mui';

import { PriorityRating } from '~/components/PriorityRating/PriorityRating';
import { Action, Target, useTrackInteraction } from '~/hooks/useTrackInteraction/useTrackInteraction';

import { NEGOTIATION_DEMAND_UPDATE_PRIORITY_MUTATION } from './DemandPriority.mutation.gql';

type DemandPriorityProps = {
  priority?: number | null;
  id: string;
};

export const DemandPriority = ({ priority, id }: DemandPriorityProps) => {
  const { hasPermission } = usePermissions();
  const track = useTrackInteraction();
  const { onError } = useCustomSnackbar();
  const [updateDemand] = useMutation(NEGOTIATION_DEMAND_UPDATE_PRIORITY_MUTATION, { onError });
  return (
    <PriorityRating
      value={priority}
      disabled={!hasPermission(Permission.DemandEditSetPriority)}
      onChange={async (_event, value) => {
        const priority = value || 0;
        await updateDemand({
          variables: {
            id,
            data: {
              priority,
            },
          },
          optimisticResponse: {
            tesseract: {
              demand: {
                priority: {
                  update: {
                    __typename: 'TsrctDemand',
                    id,
                    priority,
                  },
                },
              },
            },
          },
        });
        track(Target.DEMAND_PRIORITY, Action.UPDATED, { id, priority });
      }}
    />
  );
};
